export function updateMetaTags({
  title = 'Greek Island Ferry Tickets | Aktoploika.eu',
  description = 'Book ferry tickets to Greek islands online. Find the best prices for ferries to Mykonos, Santorini, Crete and more destinations. Compare prices and book your tickets easily.',
  keywords = 'ferry tickets, greek islands, book ferry tickets, mykonos ferry, santorini ferry, crete ferry, greek ferries',
  image = '/og-image.jpg',
  url = 'https://aktoploika.eu'
}) {
  document.title = title

  // Update meta tags
  const metaTags = {
    description: description,
    keywords: keywords,
    'og:title': title,
    'og:description': description,
    'og:image': image,
    'og:url': url,
    'og:type': 'website',
    'twitter:card': 'summary_large_image',
    'twitter:title': title,
    'twitter:description': description,
    'twitter:image': image
  }

  Object.entries(metaTags).forEach(([name, content]) => {
    // Update Open Graph and Twitter tags
    if (name.startsWith('og:') || name.startsWith('twitter:')) {
      let element = document.querySelector(`meta[property="${name}"]`)
      if (!element) {
        element = document.createElement('meta')
        element.setAttribute('property', name)
        document.head.appendChild(element)
      }
      element.setAttribute('content', content)
    } 
    // Update regular meta tags
    else {
      let element = document.querySelector(`meta[name="${name}"]`)
      if (!element) {
        element = document.createElement('meta')
        element.setAttribute('name', name)
        document.head.appendChild(element)
      }
      element.setAttribute('content', content)
    }
  })
}

export function addStructuredData(data) {
  // Remove any existing structured data
  const existingScript = document.querySelector('#structured-data')
  if (existingScript) {
    existingScript.remove()
  }

  // Add new structured data
  const script = document.createElement('script')
  script.setAttribute('id', 'structured-data')
  script.setAttribute('type', 'application/ld+json')
  script.textContent = JSON.stringify(data)
  document.head.appendChild(script)
}

export function getWebsiteStructuredData() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Aktoploika.eu",
    "url": "https://aktoploika.eu",
    "description": "Book ferry tickets to Greek islands online. Find the best prices for ferries to Mykonos, Santorini, Crete and more destinations.",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://aktoploika.eu/destinations/{search_term_string}",
      "query-input": "required name=search_term_string"
    }
  }
}

export function getTravelServiceStructuredData(destination) {
  return {
    "@context": "https://schema.org",
    "@type": "TravelService",
    "name": `Ferry Service to ${destination.name}`,
    "description": destination.description,
    "provider": {
      "@type": "Organization",
      "name": "Aktoploika.eu",
      "url": "https://aktoploika.eu"
    },
    "areaServed": {
      "@type": "Place",
      "name": destination.name,
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "GR"
      }
    }
  }
}
